import React, { useState } from 'react';
import { radii, shadows, getActiveTheme, resolveThemeName } from './tokens';

export default function Card({ children, onClick, hover = true, padded = true, className = '', style = {}, role }) {
  const [isHover, setIsHover] = useState(false);
  const theme = getActiveTheme();
  const themeName = resolveThemeName();
  const isPremiumLight = themeName === 'auroraExecutiveLight' || themeName === 'redLightPremium';
  const baseShadow = theme?.cardShadow || shadows.sm;
  const hoverShadow = theme?.cardShadowHover || shadows.md;
  const radius = theme?.cardRadius != null ? Number(theme.cardRadius) : radii.md;
  const transition = theme?.transitionFast || 'all 120ms ease';
  const baseStyle = {
    borderRadius: radius,
    boxShadow: isHover && hover ? hoverShadow : baseShadow,
    transform: isHover && hover && isPremiumLight ? 'translateY(-2px)' : undefined,
    border: `1px solid ${theme.border}`,
    background: theme.surface,
    transition,
    ...style,
  };
  const classes = `${padded ? 'p-4' : ''} ${className}`;
  const commonProps = {
    className: classes,
    style: baseStyle,
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => setIsHover(false),
  };
  if (onClick) {
    return (
      <button {...commonProps} onClick={onClick} role={role || 'button'}>
        {children}
      </button>
    );
  }
  return (
    <div {...commonProps} role={role}>
      {children}
    </div>
  );
}
